<template src="./auditlogdata.html"></template>
<script>
import Axios from "axios";
import TaskAction from "@/config/TaskAction.js";
var moment = require("moment");

export default {
  props: {
    vrm: String,
    entity_type: String,
    ref_id:Number
  },
  filters: {
    date: function (data) {
      var sendDate = "N/A";
      if (data != "" && data != null) {
        sendDate = moment(data).format("DD-MM-YYYY");
      }
      return sendDate;
    },
    showstring: function (data) {
      if (data == "" || data == null) {
        return "";
      } else {
        return data.replaceAll("_", " ");
      }
    },
  },
  data() {
    return {
      basic: {
        currentPage: 1,
        totalPages: 0,
      },

      ShowLoader: false,
      auditLogModule: false,
      SearchKey: "",
      fromDate: "",
      toDate: "",
      user: "",
      task: "",
      AllUserList: [],
      AuditLogList: [],
      EntityTypes: [],
      audit_log_excel_data: [],
      TaskAction: TaskAction,
      ShowAuditInfoModel: "",
      AuditInfoDetails: [],
      ColumnTitle: "VRM/Reg No/Driver/Asset Name",
    };
  },
  mounted() {
    var AccountPermissions = JSON.parse(
      localStorage.getItem("AccountPermissions")
    );
    var FleetSubscription = JSON.parse(
      localStorage.getItem("FleetSubscription")
    );
    var FleetSubscriptionModules = JSON.parse(FleetSubscription.fleet_modules);
    if ( FleetSubscriptionModules["Audit Log"]  || FleetSubscriptionModules["Audit Logs"] ) {
      this.auditLogModule = true;
    }

    if(this.entity_type == "vehicle"){
      this.ColumnTitle = 'VRM';
    }else if(this.entity_type == "driver"){
      this.ColumnTitle = 'Driver Name';
    }else if(this.entity_type == "asset"){
      this.ColumnTitle = 'Asset Name';
    }else if(this.entity_type == "trailer"){
      this.ColumnTitle = 'Reg No';
    }
    
    this.GetAuditLogList();
    this.GetAllFleetUserList();
  },

  methods: {
    SearchVehicle() {
      this.GetVehicleChecksList("search");
    },
    GetAllFleetUserList(type = "") {
      var obj = { token: localStorage.getItem("token") };
      Axios.post(Endpoints.User.AllUser, obj).then((Response) => {
        if (Response?.data?.success) {
          this.AllUserList = Response.data.users;
        }
      });
    },
    GetAuditLogList(type = "") {
      var obj = { token: localStorage.getItem("token") };
           
      if (type == "search") {
        obj.user = this.user;
        obj.task = this.task;
        obj.fromDate = this.fromDate;
        obj.toDate = this.toDate;
      }
      obj.vrm = this.vrm;
      obj.entity_type = this.entity_type; 
      obj.ref_id = this.ref_id; 

      this.ShowLoader = true;
      Axios.post(Endpoints.AuditLog.List, obj).then((Response) => {
        this.ShowLoader = false;
        if (Response?.data?.success) {
          this.AuditLogList = Response.data.AuditLogList;
          this.EntityTypes = Response.data.EntityTypes;
          this.fromDate = Response.data.fromDate;
          this.toDate = Response.data.toDate;
          this.audit_log_excel_data = [];
          if (this.AuditLogList.length > 0) {
            this.AuditLogList.forEach((element, index) => {
              var obj = {};
              var task_status = "";
              if (element.task_status == "orange") {
                var task_status = "Upcoming";
              } else if (element.task_status == "yellow") {
                var task_status = "Warning";
              } else if (element.task_status == "red") {
                var task_status = "Expired";
              }
              var task_action = "";
              if(element.event_type =='missing_asset' || element.event_type =='recovered_asset'){
                this.AuditLogList[index]['vrm'] = element.data['name'] ? element.data['name']:element.data['vrm'];
                this.AuditLogList[index]['action_by'] =  element.DriverData;
              } 
              
              if(element.event_type=='assetscheck'){
                this.AuditLogList[index]['vrm'] = element.data['vrm'] ? element.data['vrm']:'';
                this.AuditLogList[index]['event_title'] = element.data['event_title'] ? element.data['event_title']:'';
                this.AuditLogList[index]['entity_type'] = 'asset';
                this.AuditLogList[index]['event_type'] = element.event_type ? element.event_type:'';
               if (
                element.task_action &&
                this.TaskAction.assetcheck[element.task_action]
              ) {
                var task_action =
                  this.TaskAction.assetcheck[element.task_action];
              }
                
              } 

              if (
                element.event_type == "vehiclecheck" &&
                element.task_action &&
                this.TaskAction.vehiclecheck[element.task_action]
              ) {
                var task_action =
                  this.TaskAction.vehiclecheck[element.task_action];
              }
              if (
                element.event_type == "document" &&
                element.task_action &&
                this.TaskAction.document[element.task_action]
              ) {
                var task_action = this.TaskAction.document[element.task_action];
              }
              if (
                element.event_type == "vehicle_mot_due" &&
                element.task_action &&
                this.TaskAction.vehicle_mot_due[element.task_action]
              ) {
                var task_action =
                  this.TaskAction.vehicle_mot_due[element.task_action];
              }
              if (
                element.event_type == "vehicle_mot_appointment" &&
                element.task_action &&
                this.TaskAction.vehicle_mot_appointment[element.task_action]
              ) {
                var task_action =
                  this.TaskAction.vehicle_mot_appointment[element.task_action];
              }
              if (
                element.event_type == "vehicle_tax_due" &&
                element.task_action &&
                this.TaskAction.vehicle_tax_due[element.task_action]
              ) {
                var task_action =
                  this.TaskAction.vehicle_tax_due[element.task_action];
              }
              if (
                element.event_type == "vehicle_insurance_expire" &&
                element.task_action &&
                this.TaskAction.vehicle_insurance_expire[element.task_action]
              ) {
                var task_action =
                  this.TaskAction.vehicle_insurance_expire[element.task_action];
              }
              if (
                element.event_type == "vehicle_service_due" &&
                element.task_action &&
                this.TaskAction.vehicle_service_due[element.task_action]
              ) {
                var task_action =
                  this.TaskAction.vehicle_service_due[element.task_action];
              }
              if (
                element.event_type == "vehicle_service_appointment" &&
                element.task_action &&
                this.TaskAction.vehicle_service_appointment[element.task_action]
              ) {
                var task_action =
                  this.TaskAction.vehicle_service_appointment[
                    element.task_action
                  ];
              }
              if (
                element.event_type == "driver_license" &&
                element.task_action &&
                this.TaskAction.driver_license[element.task_action]
              ) {
                var task_action =
                  this.TaskAction.driver_license[element.task_action];
              }
              if (
                element.event_type == "driver_cpc" &&
                element.task_action &&
                this.TaskAction.driver_cpc[element.task_action]
              ) {
                var task_action =
                  this.TaskAction.driver_cpc[element.task_action];
              }
              if (
                element.event_type == "driver_adr" &&
                element.task_action &&
                this.TaskAction.driver_adr[element.task_action]
              ) {
                var task_action =
                  this.TaskAction.driver_adr[element.task_action];
              }

              obj["Action Date"] = element.created_at;
              obj["VRM/Reg No/Driver/Asset Name"] = element.vrm;
              obj["Entity"] = this.$options.filters.showstring(
                element.entity_type
              );
              obj["Task Type"] = this.$options.filters.showstring(
                element.event_type
              );
              obj["Task Date"] = this.$options.filters.date(element.task_date);
              obj["Task"] = element.event_title;
              obj["Task Status"] = task_status;
              obj["Task Action"] = task_action;
              obj["Notes"] = element.task_notes;
              obj["Documents"] = "";
              obj["Action By"] = typeof element.action_by.name != 'undefined' ? element.action_by.name :'';
              this.audit_log_excel_data.push(obj);
            });
          }
        }        
      });
    },
    ShowAuditInfoPopup(event) {
      this.ShowAuditInfoModel = true;
      this.AuditInfoDetails = event;
    },
  },
};
</script> 

<style type="text/css">
.auditloglist .table th,
.table td {
  padding: 0.5rem !important;
}
.auditloglist td.w100 {
  width: 100px !important;
  min-width: 100px !important;
}
.auditloglist td.w120 {
  width: 120px !important;
  min-width: 120px !important;
}
.auditloglist td.w150 {
  width: 150px !important;
  min-width: 150px !important;
}
.quick-view-export {
  position: absolute;
  left: 125px !important;
  top: 17px;
}
.auditloglist th{
    padding-bottom: 19px !important;
}
.search-data{
    padding: 12px 15px !important;
}
.modal-body {
  max-height: 70vh; /* 70% of the viewport height */
  overflow-y: auto;
}
</style>
